export const DEFAULT_SUPPORT_PHONE = '+596 596 00 00 00';
export const DEFAULT_SUPPORT_EMAIL = 'support@universalcold.fr';

export const normalizeTelHref = (phone) => {
  const raw = String(phone || '').trim();
  if (!raw) return '';
  const compact = raw.replace(/[^\d+]/g, '');
  if (!compact) return '';
  const normalized = compact.startsWith('+') ? compact : `+${compact.replace(/^\+/, '')}`;
  return `tel:${normalized}`;
};

export const normalizeMailtoHref = (email) => {
  const trimmed = String(email || '').trim();
  return trimmed ? `mailto:${trimmed}` : '';
};

export const fallbackSupportContact = () => ({
  phone: DEFAULT_SUPPORT_PHONE,
  email: DEFAULT_SUPPORT_EMAIL,
  telHref: normalizeTelHref(DEFAULT_SUPPORT_PHONE),
  mailtoHref: normalizeMailtoHref(DEFAULT_SUPPORT_EMAIL)
});
